<template>
  <div class="form-lower password">
    <lang />

  <section class="wrapper">
    <div class="form_ttl">
      <h1>
        <router-link :to="{ name: 'Home', params: { lang: $route.params.lang }}">
          <img src="@/assets/img/client/logo.png" alt="GLOCALY">
        </router-link>
      </h1>
    </div>
    <div class="password_contents">
      <div>
        <div class="form_wrapper">
          <h2>{{ $t('reset') }}<span class="ilB">{{ $t('the_password') }}</span></h2>
          <form>
            <p>{{ $t('reset_pass_header') }}</p>
            <label>{{ $t('new_password') }}<input v-model="data.password" :type="passwordShowHide">
              <span class="field-icon" @click="showPasswordNew = !showPasswordNew">
                <img src="@/assets/img/client/mdi-eye-off.png" alt="" width="33" height="21" v-if="showPasswordNew">
                <img src="@/assets/img/client/mdi-eye.png" alt="" width="33" height="21" v-else>
              </span>
            </label>
            <label>{{ $t('new_password_confirm') }}<input :type="passwordShowHideNew">
              <span class="field-icon" @click="showPasswordNewConfirm = !showPasswordNewConfirm">
                <img src="@/assets/img/client/mdi-eye-off.png" alt="" width="33" height="21" v-if="showPasswordNewConfirm">
                <img src="@/assets/img/client/mdi-eye.png" alt="" width="33" height="21" v-else>
              </span>
            </label>
            <button type="button" class="brown_btn" @click="updatePassword">{{ $t('password_reset_button') }}</button>
          </form>
        </div>
      </div>
    </div>
  </section>

  </div>
</template>

<script>
import lang from '@/components/client/language/language'
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      showPasswordNew: true,
      showPasswordNewConfirm: true,
      data: {
        email_address: null,
        password: null
      }
    }
  },
  created () {
    this.setEmail()
  },
  methods: {
    ...mapActions('login', ['clientResetPassword']),
    setEmail: function () {
      this.data.email_address = this.currentEmail
    },
    updatePassword: function () {
      this.clientResetPassword(this.data)
    }
  },
  computed: {
    ...mapState('login', ['currentEmail']),
    passwordShowHide () {
      return this.showPasswordNew ? 'password' : 'text'
    },
    passwordShowHideNew () {
      return this.showPasswordNewConfirm ? 'password' : 'text'
    }
  },
  components: {
    lang
  }
}
</script>

<style lang="scss" src="@/assets/sass/client/index.scss">

</style>
